var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 38,
    viewBox: "0 0 42 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4015 5.01168C15.4598 2.14865 10.1579 0.421078 5.02148 0V29.3552C10.1574 29.7647 15.4499 31.445 20.4015 34.2346V5.01168Z",
    fill: "#008080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.2345 35.7524C20.6378 35.8922 21.0624 35.8982 21.4656 35.7584C27.2406 33.2214 33.2886 32.0794 39.2004 32.3425V3.27905C38.6683 3.2549 38.1327 3.24936 37.5952 3.25138V30.2134L37.1731 30.2416C31.8861 30.5923 26.4069 32.343 21.3096 35.2966C21.0153 35.3987 20.6968 35.3987 20.403 35.2966C15.3052 32.343 9.82646 30.5923 4.53944 30.2416L4.11635 30.2134V3.25138C3.57933 3.24936 3.04329 3.2544 2.51172 3.27905V32.3425C8.42296 32.0789 14.4581 33.2153 20.2345 35.7524Z",
    fill: "#008080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41.7096 6.54158C41.1795 6.46662 40.641 6.42688 40.106 6.37305V33.313L39.6264 33.2848C33.5849 32.9331 27.2114 34.1788 21.3086 36.8391L20.8548 37.0307L20.4015 36.8391C14.4977 34.1788 8.12474 32.9326 2.0832 33.2848L1.60414 33.313V6.37305C1.0686 6.42738 0.53009 6.46712 0 6.54158V36.0759C0.294274 36.2303 0.517209 36.4522 0.517209 36.4522C6.93327 35.5718 13.5926 35.6795 19.9274 37.7859C20.2187 37.7567 20.5278 37.7381 20.8553 37.7381C21.1828 37.7381 21.4919 37.7567 21.7827 37.7859C28.1165 35.679 34.7769 35.5718 41.1924 36.4522C41.1924 36.4522 41.4272 36.2198 41.7096 36.0759V6.54158Z",
    fill: "#008080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.1864 1.84228V12.2183L26.2146 9.83471L24.1364 12.2183V3.51603C23.1832 3.97383 22.2395 4.47238 21.3086 5.01219V34.2346C26.2592 31.445 31.5532 29.7647 36.6886 29.3552V0C33.8752 0.230914 31.0122 0.855739 28.1864 1.84228Z",
    fill: "#008080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.578d774fb8ee7e44760823ba8a29b741.svg";
export { ForwardRef as ReactComponent };